// This file was automatically generated from appchart.refpanel.uploadPtPhoto.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.uploadPtPhoto');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.uploadPtPhoto.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="upload-profile-photo-dialog"><div class="photo-section el8UploadPicWrap"><img class="el8UploadProfilePhoto"></img></div></div>');
  if (!opt_sb) return output.toString();
};
